module.exports = __webpack_public_path__ + "img/can i eat you.285fa310.png";